// extracted by extract-css-chunks-webpack-plugin
module.exports = {"spacer":"css-3KPmpuK_kg"};